module.exports = __webpack_public_path__ + "static/media/sports (1).57d11e20.webp";